import React, { useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Row } from "reactstrap";
import { FAQData } from "../Data/ComponentsData/componentsdata";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return (
    <section className='theme-bg faq' id='faq'>
      <div className='animation-circle-inverse'>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <Container>
        <Row>
          <Col md={12} className='text-center'>
            <div className='section-title'>
              <h2 className='text-white'>Frequently asked Question</h2>
              <img src='assets/images/white-line.png' alt='title-line' className='img-fluid' />
            </div>
          </Col>
        </Row>
        <Row className='faq-row'>
          <Col lg={6}>
            <div className='accordion'>
              {FAQData.map((item, index) => (
                <Card key={item.id} className='mb-3'>
                  <CardHeader id={`heading${item.id}`}>
                    <h5 className='mb-0'>
                      <Button className={`${activeIndex === index ? "active-faq" : ""}`} color='' onClick={() => toggle(index)}>
                        {item.question}
                        <i className='fa fa-angle-down pull-right'></i>
                      </Button>
                    </h5>
                  </CardHeader>
                  <Collapse isOpen={activeIndex === index} id={`collapse${item.id}`}>
                    <CardBody>{item.answer}</CardBody>
                  </Collapse>
                </Card>
              ))}
            </div>
          </Col>
          <Col lg={6} className='text-center'>
            <img src='assets/images/faq.png' className='img-fluid' alt='' />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQ;
